module.exports = "/packs/mokumoku_guide_banner-41e916d35516b173fd02268f90183746.png";